import { RoutePlanElement, RoutePlanType, WaypointAddress } from 'src/app/models/route';
import { RouteListElement } from 'src/app/models/route-list';

export const PLANNING_PANEL_MIN_HEIGHT = 255;

/** Tallest the panel gets on the compact layout: most of the screen in landscape, 3/5 of it in portrait. */
export function getPlanningPanelMaxHeight(viewportWidth: number, viewportHeight: number): number {
  return viewportWidth > viewportHeight
    ? viewportHeight / 5 * 4.4
    : viewportHeight / 5 * 3;
}

/** A dragged height kept at least PLANNING_PANEL_MIN_HEIGHT and at most the max height (the max wins on tiny screens). */
export function clampPlanningPanelHeight(height: number, viewportWidth: number, viewportHeight: number): number {
  if (height < PLANNING_PANEL_MIN_HEIGHT) {
    height = PLANNING_PANEL_MIN_HEIGHT;
  }
  const maxHeight = getPlanningPanelMaxHeight(viewportWidth, viewportHeight);
  if (height > maxHeight) {
    height = maxHeight;
  }
  return height;
}

/**
 * The RoutePlan index of the `index`-th (0-based) element of `type`, e.g. the 2nd charger.
 * Past the last such element it gives the last RoutePlan index; for an empty plan, -1.
 */
export function getRoutePlanIndex(routePlan: RoutePlanElement[], type: RoutePlanType, index: number): number {
  let routePlanIndex = 0;
  let typeIndex = 0;
  while (typeIndex <= index && routePlanIndex < routePlan.length) {
    if (routePlan[routePlanIndex].Type === type) {
      typeIndex++;
    }
    routePlanIndex++;
  }
  return routePlanIndex - 1;
}

/** True when a route list row has not been filled in yet (its position is 0,0). */
export function hasEmptySearchInput(routeList: RouteListElement[]): boolean {
  return routeList.some(el => el.lat == 0 && el.lng == 0);
}

/**
 * Route list rows for reverse-geocoded waypoint addresses. Rows that are charging stations keep
 * their name; the others get the formatted address.
 */
export function mapReverseGeocodedRouteList(addresses: WaypointAddress[], current: RouteListElement[],
  formatAddress: (addr: WaypointAddress, lat: number, lng: number) => string): RouteListElement[] {
  return addresses.map((addr, i) => {
    const existing = current[i];
    // Charging stations already have their name set — don't overwrite with a geocoded street address
    const display_name = existing?.csid
      ? existing.display_name
      : formatAddress(addr, addr.Location.lat, addr.Location.lng);
    return { display_name, lat: addr.Location.lat, lng: addr.Location.lng, wp: i, csid: existing?.csid };
  });
}
